import { useTranslation } from 'react-i18next';

import { ServiceTypes } from '../../modules/journey-canvas/utility/TypeDefs';
import { getServiceTypeIcon } from './utility/Helpers';
import { CircleBadgeProps, JourneyBuilderFooterProps } from './utility/Types';

import classes from './JourneyBuilderFooter.module.scss';

/**
 * @description Component to create circle badge
 * @param {CircleBadgeProps} count - Config count.
 */
const CircleBadge = ({ count }: CircleBadgeProps) => (
  <div className={classes['jd-circle-badge']} data-testid="sr-counter-badge">
    <div className={classes['jd-circle-badge-text']}>
      {count}
    </div>
  </div>
);

export const JourneyBuilderFooter: React.FC<JourneyBuilderFooterProps> = ({ summaryStats, isCem }: JourneyBuilderFooterProps) => {
  // hooks
  const { t: translate } = useTranslation();

  return (
    <div className={classes['journey-canvas-footer']}>
      <div className={classes['icon-wrapper']}>
        <div className={classes['icon-item']}>
          <img src={`${getServiceTypeIcon(ServiceTypes.BUSINESS)}`} alt="businessServiceIcon" className={classes['icon-img']} />
          {translate('journey_builder_footer.lbl_business_service')}
        </div>
        <div className={classes['icon-item']}>
          <img src={`${getServiceTypeIcon(ServiceTypes.EXTERNAL)}`} alt="externalServiceIcon" className={classes['icon-img']} />
          {translate('journey_builder_footer.lbl_external_service')}
        </div>
        <div className={classes['icon-item']}>
          <img src={`${getServiceTypeIcon(ServiceTypes.MQ)}`} alt="mqServiceIcon" className={classes['icon-img']} />
          {translate('journey_builder_footer.lbl_mq_service')}
        </div>
        <div className={classes['icon-item']}>
          <img src={`${getServiceTypeIcon(ServiceTypes.DB2)}`} alt="db2ServiceIcon" className={classes['icon-img']} />
          {translate('journey_builder_footer.lbl_db2_service')}
        </div>
        <div className={classes['icon-item']}>
          <img src={`${getServiceTypeIcon(ServiceTypes.SOAP)}`} alt="soapServiceIcon" className={classes['icon-img']} />
          {translate('journey_builder_footer.lbl_soap_service')}
        </div>
      </div>
      <div>
        <div className={classes['summary-label']}>
          {translate('journey_builder_footer.lbl_summary')}
        </div>
        <div className={classes['summary-item']}>
          {translate('journey_builder_footer.lbl_services')}
          <CircleBadge count={summaryStats.serviceCount} />
        </div>
        <div className={classes['summary-item']}>
          {translate('journey_builder_footer.lbl_events')}
          <CircleBadge count={summaryStats.eventCount} />
        </div>
        {!isCem && (
          <div className={classes['summary-item']}>
            {translate('journey_builder_footer.lbl_cem')}
            <CircleBadge count={summaryStats.cemCount} />
          </div>
        )}
      </div>
    </div>
  );
};
